export const ACTIVE_TAB = 'ACTIVE_TAB';
export const SECTION_TYPE = 'SECTION_TYPE';
export const CONTACTS = 'CONTACTS';
export const CONTACTS_PROCESSING = 'CONTACTS_PROCESSING';
export const CONTACTS_ERRORS = 'CONTACTS_ERRORS';
export const CONTACTS_NOT_FOUND = 'CONTACTS_NOT_FOUND';



// WEBPACK FOOTER //
// ./src/components/contact/getter.js